import { Typography } from "@/components";
import { fromMsToTime } from "@/libraries/date";
import type { MessageDiscussion } from "@/types";
import isEqual from "fast-deep-equal";
import { memo } from "react";
import { FlagIcons } from "./FlagIcons";

interface MessageActionProps {
	flag: MessageDiscussion["_flag"];
	created_at: number;
	unread_thread_messages?: number;
}

const MessageAction = (props: MessageActionProps) => {
	const { flag, created_at, unread_thread_messages = 0 } = props;
	return (
		<div className="flex flex-col gap-1 items-end">
			<div className="flex items-center gap-2">
				<Typography fontWeight={400} fontSize={10}>
					{fromMsToTime(created_at)}
				</Typography>
				{FlagIcons[flag]}
			</div>
			{unread_thread_messages ? (
				<div className="w-6 h-6 flex justify-center items-center text-danger-300 bg-danger-200 rounded-full">
					<Typography fontWeight={500} fontSize={12}>
						{unread_thread_messages}
					</Typography>
				</div>
			) : null}
		</div>
	);
};

export default memo(MessageAction, isEqual);
